


























import Vue from 'vue'
import { DayRangePickerElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'DayRangePickerEl',

  props: {
    templateItemData: {
      type: Object as () => DayRangePickerElInterface,
      required: true
    }
  },

  mounted () {
    this.initializeDayRangeData()
  },

  data: () => ({
    days: ['P', 'U', 'S', 'Č', 'P', 'S', 'N'] as Array<string>,
    selected: [] as Array<number>
  }),

  computed: {
    mask (): string {
      let mask = ''
      this.days.forEach((val, index) => {
        this.selected.includes(index) ? mask += '1' : mask += '0'
      })
      return mask
    },
    disabled () {
      return this.templateItemData.type === 'dayRange'
    }
  },

  methods: {
    getStyle (dayIndex: number): string {
      if (this.selected.includes(dayIndex)) {
        return 'background-color: ' + this.templateItemData.circleColor + '; color: white'
      }
      if (this.$vuetify.theme.dark) {
        return 'background-color: #00182C; color: var(--v-lightGray2-darken2);'
      }
      return 'background-color: white; color: var(--v-lightGray2-darken2);'
    },
    getBorder (dayIndex: number): string {
      if (this.selected.includes(dayIndex)) {
        return ''
      }
      if (this.$vuetify.theme.dark) {
        return 'border: 2px solid; '
      }
      return !this.disabled ? 'border: 2px solid ' + this.templateItemData.circleColor : ''
    },
    initializeDayRangeData (): void {
      this.templateItemData.mask.replace(/\s/g, '').split('').forEach((val, index) => {
        if (val === '1') {
          this.selected.push(index)
        }
      })
    }
  }
})
